import type { BotConfigurationFormData } from '../components/admin/BotConfigurationForm';

export function noragFormToPayload(data: BotConfigurationFormData): {
  noragEnabled: boolean;
  noragEmpresaId?: number;
  noragApiUrl?: string;
  noragPathPrefix?: string;
  noragBotToken?: string;
  clearNoragBotToken?: boolean;
} {
  const empresaId = data.noragEmpresaId ? Number.parseInt(data.noragEmpresaId, 10) : Number.NaN;
  return {
    noragEnabled: Boolean(data.noragEnabled),
    noragEmpresaId: Number.isInteger(empresaId) && empresaId > 0 ? empresaId : undefined,
    noragApiUrl: data.noragApiUrl?.trim() || undefined,
    noragPathPrefix: data.noragPathPrefix?.trim() || undefined,
    noragBotToken: data.noragBotToken?.trim() || undefined,
    clearNoragBotToken: data.clearNoragBotToken || undefined,
  };
}
